function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from 'react';
import { useTranslation } from '../../_utils/i18n';
import { SLModal } from '@yy/sl-admin-components';
import { SLButton } from '@yy/sl-admin-components';
import { EPayMethodType, EChannelId, EBillStatus } from '../../constants';
import { useConfigAtomValues, useDataAtom, useStateAtom } from '../../state';
import { postWechatPay, getBillStatus } from '../../services';
import { useRequest, useMemoizedFn } from 'ahooks';
import { usePayMerchantInfo } from '../../hooks';
import { catchWith } from '../../_utils/tool';
import iconWechatPay from './images/wechatPay.png';
import { WeixinPayWrapper } from './styled';
var WeiXinPayModal = function WeiXinPayModal(props) {
  var _wechatProps$price;
  var priceString = props.priceString,
    onError = props.onError,
    onPaySuccess = props.onPaySuccess,
    onPayCancel = props.onPayCancel;
  var _useConfigAtomValues = useConfigAtomValues(),
    billId = _useConfigAtomValues.billId,
    appId = _useConfigAtomValues.appId,
    bizType = _useConfigAtomValues.bizType,
    subBizType = _useConfigAtomValues.subBizType,
    wechatProps = _useConfigAtomValues.wechatProps,
    onCancelPay = _useConfigAtomValues.onCancelPay;

  // bizType有值，则代表主站，基参需要保留；bizType没值，则代表非主站，基参不需要再传
  var baseReqParams = React.useMemo(function () {
    return bizType === 'SHOPLINE' ? {
      appId: appId,
      bizType: bizType,
      subBizType: subBizType
    } : {};
  }, [appId, bizType, subBizType]);
  var _useDataAtom = useDataAtom(),
    _useDataAtom2 = _slicedToArray(_useDataAtom, 2),
    productInfo = _useDataAtom2[0].productInfo,
    setDataAtom = _useDataAtom2[1];
  var _useStateAtom = useStateAtom(),
    _useStateAtom2 = _slicedToArray(_useStateAtom, 2),
    weiXinPayModalVisible = _useStateAtom2[0].weiXinPayModalVisible,
    setStateAtom = _useStateAtom2[1];

  // 是否开启关闭前确认
  var isNeedConfirmBeforeClosing = useMemoizedFn(function () {
    if (typeof (wechatProps === null || wechatProps === void 0 ? void 0 : wechatProps.closingConfirmed) === 'function') {
      return wechatProps.closingConfirmed(productInfo);
    }
    return false;
  });

  // 是否关闭支付弹窗的时候调用取消的api
  var isInvokeCancelApiOnClose = useMemoizedFn(function () {
    if (typeof (onCancelPay === null || onCancelPay === void 0 ? void 0 : onCancelPay.invokeCancelApiOnClose) === 'function') {
      return onCancelPay.invokeCancelApiOnClose({
        billId: billId,
        payMethod: EPayMethodType.Wechat
      });
    }
    return false;
  });
  var queryQrcodeParams = _objectSpread(_objectSpread({}, baseReqParams), {}, {
    billId: billId
  });

  // 获取支付商家信息
  var usePayMerchantInfoReturns = usePayMerchantInfo({
    payChannel: EChannelId.wechat
  }, {
    manual: true
  });
  var _useTranslation = useTranslation(),
    i18n = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    imgError = _useState2[0],
    setImgError = _useState2[1];
  var invokePostWechatPay = useMemoizedFn( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var payMerchantInfo, _yield$catchWith, response, error;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return usePayMerchantInfoReturns.getter();
          case 2:
            payMerchantInfo = _context.sent;
            _context.next = 5;
            return catchWith(postWechatPay(_objectSpread(_objectSpread({}, queryQrcodeParams), {}, {
              channelAppId: payMerchantInfo.payMerchantId
            })));
          case 5:
            _yield$catchWith = _context.sent;
            response = _yield$catchWith.data;
            error = _yield$catchWith.error;
            if (!(response && response.data)) {
              _context.next = 10;
              break;
            }
            return _context.abrupt("return", response.data);
          case 10:
            if (error) {
              onError === null || onError === void 0 ? void 0 : onError({
                code: error === null || error === void 0 ? void 0 : error.code,
                msg: error === null || error === void 0 ? void 0 : error.msg,
                billId: billId
              });
            }
          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })));

  // 关闭微信支付弹窗
  var closeModal = function closeModal() {
    setStateAtom(function (draft) {
      draft.weiXinPayModalVisible = false;
    });
  };
  var _useRequest = useRequest(function () {
      return invokePostWechatPay();
    }, {
      manual: true,
      pollingInterval: 10 * 60 * 1000
    }),
    qrcodeData = _useRequest.data,
    qrcodeLoading = _useRequest.loading,
    queryQrcode = _useRequest.runAsync,
    cancelQueryQrcode = _useRequest.cancel;

  // 查询账单状态回调
  var onQueryBillStatusCallback = useMemoizedFn(function (res) {
    var _res$data, _res$data2;
    if ((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.status) === EBillStatus.PAYED) {
      setDataAtom(function (draft) {
        draft.billStatus = EBillStatus.PAYED;
      });
      closeModal();
      cancelQueryBillStatus();
      onPaySuccess === null || onPaySuccess === void 0 ? void 0 : onPaySuccess();
    }
    if ((res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.status) === EBillStatus.CANCELED) {
      setDataAtom(function (draft) {
        draft.billStatus = EBillStatus.CANCELED;
      });
      closeModal();
      cancelQueryBillStatus();
      cancelQueryQrcode();
    }
  });
  var _useRequest2 = useRequest(function () {
      return getBillStatus(queryQrcodeParams);
    }, {
      manual: true,
      pollingInterval: 1000
    }),
    queryBillStatusRst = _useRequest2.data,
    queryBillStatus = _useRequest2.runAsync,
    cancelQueryBillStatus = _useRequest2.cancel;
  var clearTimer = useMemoizedFn(function () {
    cancelQueryQrcode();
    cancelQueryBillStatus();
  });
  var onCancel = function onCancel() {
    if (isNeedConfirmBeforeClosing() && billId) {
      var modalIns = SLModal.confirm({
        className: 'confirmModal',
        title: i18n('wechat.toast3'),
        okText: i18n('wechat.toast1'),
        cancelText: i18n('wechat.toast2'),
        onCancel: function () {
          var _onCancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
            var _response$data, _finallyFn;
            var response, status, finallyFn;
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return queryBillStatus();
                  case 2:
                    response = _context2.sent;
                    status = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.status;
                    if ([EBillStatus.CANCELED, EBillStatus.UNPAID].includes(status)) {
                      finallyFn = onPayCancel;
                    } else {
                      finallyFn = onPaySuccess;
                    }

                    // 关闭当前确认弹窗
                    modalIns.destroy();
                    closeModal();
                    clearTimer();
                    // 执行支付成功 or 取消账单接口
                    (_finallyFn = finallyFn) === null || _finallyFn === void 0 ? void 0 : _finallyFn();
                  case 9:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));
          function onCancel() {
            return _onCancel.apply(this, arguments);
          }
          return onCancel;
        }(),
        onOk: function () {
          var _onOk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
            return _regeneratorRuntime().wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    // 关闭当前确认弹窗
                    modalIns.destroy();
                    closeModal();
                    clearTimer();
                    onPaySuccess === null || onPaySuccess === void 0 ? void 0 : onPaySuccess();
                  case 4:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));
          function onOk() {
            return _onOk.apply(this, arguments);
          }
          return onOk;
        }()
      });
    } else {
      closeModal();
      clearTimer();
      onPayCancel === null || onPayCancel === void 0 ? void 0 : onPayCancel({
        invokeCancelApi: isInvokeCancelApiOnClose()
      });
    }
  };
  var onQRCodeImageError = function onQRCodeImageError() {
    clearTimer();
    setImgError(true);
  };
  var onAfterClose = function onAfterClose() {
    var _wechatProps$onAfterC;
    wechatProps === null || wechatProps === void 0 ? void 0 : (_wechatProps$onAfterC = wechatProps.onAfterClose) === null || _wechatProps$onAfterC === void 0 ? void 0 : _wechatProps$onAfterC.call(wechatProps, billId);
  };
  var getQrcode = useMemoizedFn( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            clearTimer();
            // 目前只有微信支付
            _context4.next = 3;
            return queryQrcode();
          case 3:
            _context4.next = 5;
            return queryBillStatus();
          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  })));
  useEffect(function () {
    if (weiXinPayModalVisible) {
      getQrcode();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [weiXinPayModalVisible]);

  // 监听微信支付结果
  useEffect(function () {
    onQueryBillStatusCallback(queryBillStatusRst);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryBillStatusRst]);
  return /*#__PURE__*/React.createElement(SLModal, {
    visible: weiXinPayModalVisible,
    centered: true,
    size: "small",
    title: i18n('settlement.payway.Wechat pay'),
    okButtonProps: {
      style: {
        display: 'none'
      }
    },
    cancelText: i18n('settlement.creditbox.cancel'),
    onCancel: onCancel,
    maskClosable: false,
    afterClose: onAfterClose
  }, /*#__PURE__*/React.createElement(WeixinPayWrapper, null, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React.createElement("p", {
    className: "price"
  }, (_wechatProps$price = wechatProps === null || wechatProps === void 0 ? void 0 : wechatProps.price) !== null && _wechatProps$price !== void 0 ? _wechatProps$price : priceString), /*#__PURE__*/React.createElement("p", {
    className: "desc"
  }, i18n('settlement.WechatQRbox.save'))), !qrcodeLoading ? /*#__PURE__*/React.createElement("div", {
    className: "body"
  }, imgError || !(qrcodeData && qrcodeData.qrCodeBase64Complete) ? /*#__PURE__*/React.createElement("div", {
    className: "imgError"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text"
  }, i18n('settlement.wechatQRbox.QR code loading failed')), /*#__PURE__*/React.createElement(SLButton, {
    onClick: getQrcode
  }, i18n('settlement.wechatQRbox.Refresh QR code'))) : /*#__PURE__*/React.createElement("div", {
    className: "imgWrap"
  }, /*#__PURE__*/React.createElement("img", {
    className: "qrcode",
    onError: onQRCodeImageError,
    src: qrcodeData.qrCodeBase64Complete,
    alt: "qrcode"
  }), /*#__PURE__*/React.createElement("div", {
    className: "iconWechatPay"
  }, /*#__PURE__*/React.createElement("img", {
    src: iconWechatPay,
    alt: "wechatPay"
  })))) : /*#__PURE__*/React.createElement("div", {
    className: "body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "imgError"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "iconLoading",
    width: "26",
    height: "26",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25",
    stroke: "#356DFF",
    strokeWidth: "2",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text"
  }, i18n('settlement.wechatQRbox.loading')))))));
};
export default WeiXinPayModal;